<template>
	<div class="page-500 d-flex align-items-center justify-content-center">
		<div class="page-500-container">
			<div class="icon mb-3">
				500
			</div>
			<h1 class="title mb-2">
				Internal server error
			</h1>
			<p class="typo-body-2 color-black-45 mb-4">
				รอ 1–2 นาที แล้วกด <strong class="link" :class="{ 'link--disabled': isChecking }" @click="checkServer">"ตรวจสอบ server"</strong> เพื่อดูว่ากลับมาหรือยัง
				จากนั้นกด <strong v-if="redirectPath" class="link" @click="goBack">"กลับหน้าที่ใช้งานอยู่"</strong><template v-if="redirectPath"> หรือ </template><strong class="link" @click="logout">"Logout แล้ว Login ใหม่"</strong>
				ถ้ายังไม่หาย แจ้ง Dev พร้อม timestamp และ URL นี้
			</p>

			<!-- สาเหตุที่เป็นไปได้ -->
			<div class="info-box mb-4">
				<p class="info-box__title mb-1">
					สาเหตุที่เป็นไปได้
				</p>
				<ul class="info-box__list">
					<li>Server หรือ API service down ชั่วคราว</li>
					<li>Network หรือ Load balancer มีปัญหา</li>
					<li>Token หมดอายุพร้อมกับ server มีปัญหาพร้อมกัน</li>
				</ul>
			</div>

			<!-- Actions -->
			<div class="actions">
				<!-- Server กลับมาแล้ว: แสดงปุ่ม Back แทน -->
				<template v-if="serverStatus === true">
					<button
						class="btn btn-primary"
						@click="goBack"
					>
						Back
					</button>
				</template>

				<!-- ยังไม่ได้เช็ค หรือ server ยังไม่พร้อม -->
				<template v-else>
					<button
						class="btn btn-secondary"
						@click="checkServer"
					>
						{{ isChecking ? 'กำลังตรวจสอบ...' : 'ตรวจสอบ server' }}
					</button>

					<button
						v-if="redirectPath"
						class="btn btn-primary"
						@click="goBack"
					>
						กลับหน้าที่ใช้งานอยู่
					</button>

					<button
						class="btn btn-outline-danger"
						@click="logout"
					>
						Logout
					</button>
				</template>
			</div>
		</div>
	</div>
</template>

<script>
import { mapActions } from 'vuex';
import { checkHealthAPI } from '../services/api/health.api';
import { ROUTE_NAME } from '../enums/route';

export default {
	name: 'PageServerError',
	data() {
		return {
			isChecking: false,
			serverStatus: null, // null = ยังไม่ได้เช็ค, true = up, false = down
		};
	},
	computed: {
		redirectPath() {
			return this.$route.query.redirect || null;
		},
	},
	methods: {
		...mapActions({
			showToast: 'toast/showToast',
		}),
		async checkServer() {
			if (this.isChecking) return;
			this.isChecking = true;
			try {
				await checkHealthAPI();
				this.serverStatus = true;
				this.showToast({ header: 'Server กลับมาแล้ว', content: 'กดปุ่มกลับหน้าที่ใช้งานอยู่ หรือ Logout แล้ว Login ใหม่ได้เลย', type: 'success' });
			} catch {
				this.serverStatus = false;
				this.showToast({ header: 'Server ยังไม่พร้อม', content: 'กรุณารอสักครู่แล้วลองใหม่', type: 'danger' });
			} finally {
				this.isChecking = false;
			}
		},
		goBack() {
			if (this.redirectPath) {
				this.$router.push(this.redirectPath);
			} else {
				this.$router.back();
			}
		},
		logout() {
			this.$router.push({ name: ROUTE_NAME.LOGOUT });
		},
	},
};
</script>

<style lang="scss" scoped>
	.page-500 {
		position: absolute; // relative with .c-body
		top: 0;
		left: 0;
		width: 100%;
		height: 100%;
		align-items: center;
		text-align: center;
	}

	.page-500-container {
		max-width: rem(480);
		width: 100%;
	}

	.icon {
		display: inline-block;
		width: rem(80);
		height: rem(80);
		line-height: rem(80);
		background-color: $color-gray-100;
		text-align: center;
		font-size: rem(28);
		color: $color-gray-500;
		font-weight: 600;
		border-radius: 50%;
	}

	.title {
		font-size: rem(18);
		font-weight: 600;
		color: $color-gray-500;
	}

	.info-box {
		background-color: $color-gray-100;
		border-radius: rem(8);
		padding: rem(16);
		text-align: left;

		&--warning {
			background-color: #fffbe6;
			border: 1px solid #ffe58f;
		}

		&__title {
			font-size: rem(16);
			font-weight: 600;
			color: $color-gray-700;
			margin-bottom: 0;
		}

		&__list {
			margin-bottom: 0;
			padding-left: 20px;

			li {
				font-size: rem(14);
				line-height: 1.4;
				color: $color-gray-600;
			}
		}
	}

	.link {
		cursor: pointer;
		color: $color-black;

		&:hover {
			text-decoration: underline;
		}

		&--disabled {
			opacity: 0.4;
			cursor: not-allowed;
			pointer-events: none;
		}
	}

	.actions {
		display: flex;
		gap: rem(8);
		justify-content: center;
		flex-wrap: wrap;
	}
</style>
